import React from "react"
import TailwindProvider from "../../../shared/providers/TailwindProvider"
import { getThemeStylesheet } from "../../travel_book/avia_v3/utils/filters/build"

const RootLayout = ({ children, themeName }) => {
  const theme = getThemeStylesheet(themeName)
  return (
    // <TailwindProvider>
    //   <div data-theme={theme}>{children}</div>
    // </TailwindProvider>
    <div data-theme={theme}>{children}</div>
  )
}

export default RootLayout
